import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import lodash from 'lodash';

import { clearMemoizedWorkflow } from '../../utils/network';
import { appStorage, parseQueryString } from '../../utils/utils'
import useTranslation from '../../hooks/use-translation';
import useLoader from '../../hooks/use-loader';
import apiRequest from '../../utils/api.request';
import InputForm from '../VaccinationDetails/VaccinationDetailsWrapper/Components/InputForm';
import UpdateVaccineDetails from "./UpdateVaccineDetails";
import { _getErrorMessage } from '../VaccinationDetails/VaccinationDetailsWrapper/Utils/getErrorMessage';
import {
  ess, recordEssParams
} from '../OnBoarding/ess';
import { vaccinationApiRequestBody } from "../VaccinationDetails/VaccinationDetailsWrapper/Utils/vaccinationApiRequestBody";
import { isJhhIdVerified } from '../VaccinationCertificate/Utils/isJhhIdVerified';
import config from "../../config.json";

import './VaccinationScWrapper.css'

let auth_token;
let source_id;
let source_user_id;
let source_relation;
let source_user_relation_id;

const _calcDaysBtwDates = (date1, date2) => {
  const days = (new Date(date1).getTime() - new Date(date2).getTime()) / (86400000)
  return days;
}

const getDose2reminderDays = (vaccineName) => {
  switch (vaccineName) {
    case "Pfizer":
      return 21
    case "Moderna":
      return 28
    case "Sputnik":
      return 21
    case "Covishield":
      return 84
    case "Covaxin":
      return 28
    default:
      return 30
  }
}

const VaccinationScWrapper = ({ handleCompleteFinish, hideHeader = false }) => {
  const history = useHistory();
  const urlParams = new URLSearchParams(window.location.search);
  const params = parseQueryString();
  const { t, language } = useTranslation();
  const [employeeId, setEmployeeId] = useState("");
  const [disableNext, setDisableNext] = useState(true);
  const [employeeIdGiven, setEmployeeIdGiven] = useState(() => params.source_id !== "rfh_doc");
  const [showEmployeeIdQues, setShowEmployeeIdQues] = useState(() => params.source_id === "rfh_doc");
  const userInfoFromParams = useRef();
  const [userRelation, setUserRelation] = useState("");
  const [pageLoadError, setPageLoadError] = useState();
  const [showQuestionDose1, _setShowQuestionDose1] = useState(false)
  const [showQuestionDose2, _setShowQuestionDose2] = useState(false)
  const [checkPreviousResponseDose2, _setCheckPreviousResponseDose2] = useState(true);
  const [vaccineOptions, _setVaccineOptions] = useState();
  const { showLoading, hideLoading, loadingCount } = useLoader();
  const user_details = useRef();
  const eoiSscParams = useRef();
  const name = atob(params.t);

  const getUserVaccinationStatus = async (params) => {
    const url = config.covid_vacc_base_url + "v1/get-user-covid-info/";
    source_id = lodash.get(params, "source_id");
    switch (source_id) {
      case "emp_xp": {
        auth_token = lodash.get(params, "auth_token");
        source_user_id = lodash.get(params, "source_user_id");
        source_relation = lodash.get(params, "source_relation");
        source_user_relation_id = lodash.get(params, "source_user_relation_id");
        if (!auth_token || !source_user_id || !source_relation || (source_user_relation_id == undefined)) {
          return;
        }
        else {
          user_details.current = {
            auth_token,
            source_id,
            source_user_id,
            source_relation,
            source_user_relation_id
          };
          const dataObj = vaccinationApiRequestBody({}, user_details.current);
          const response = await apiRequest(url, dataObj, true);
          if (lodash.get(response, "status") !== "success") {
            setPageLoadError(lodash.get(response, "response.data.message", "Something went wrong, please try again"))
          } else {
            return response;
          }
        }
        break;
      }
      case "JioHealthHub": {
        auth_token = lodash.get(params, "auth_token");
        source_user_id = lodash.get(params, "source_user_id");
        if (!auth_token || !source_user_id) {
          return;
        }
        else {
          user_details.current = {
            auth_token,
            source_id: source_id.toLowerCase(),
            jhh_id: source_user_id,
          };
          const dataObj = vaccinationApiRequestBody({ jhh_id: source_user_id }, user_details.current);
          const response = await apiRequest(url, dataObj, true, false, false, false, false, false, false, false, true);
          if (lodash.get(response, "status") !== "success") {
            setPageLoadError(lodash.get(response, "response.data.message", "Something went wrong, please try again"))
          } else {
            return response;
          }
        }
        break;
      }
      default: {
        return;
      }
    }
  }

  const getUserInfoFromParams = (params) => {
    if (ess().isFromEss) {
      return {
        relation: ess().eventData.source_relation,
        gender: ess().eventData.source_gender,
        age: parseInt(ess().eventData.source_age_years, 10)
      };
    }
    else if (params.source_id === "JioHealthHub") {
      return {
        relation: params.relation,
        gender: params.gender,
        age: parseInt(params.age, 10),
      };
    }

    else if (params.source_id === "MyJio") {
      return {
        relation: params.source_relation,
        gender: params.source_gender,
        age: parseInt(params.source_age_years, 10),
      };
    }
    return {};
  };

  const _getPreviousResponse = async () => {
    const get_previous_response_url = config.covid_vacc_base_url + "v1/previous-response/";
    source_id = lodash.get(params, "source_id", "").toLowerCase();
    auth_token = lodash.get(params, "auth_token");
    source_user_id = lodash.get(params, "source_user_id");
    source_relation = lodash.get(params, "source_relation");
    source_user_relation_id = lodash.get(params, "source_user_relation_id");

    switch (source_id) {
      case "emp_xp": {
        if (!auth_token || !source_user_id || !source_relation || (source_user_relation_id == undefined)) {
          return;
        }
        const userDetailsObj = {
          auth_token,
          source_id,
          source_user_id,
          source_relation,
          source_user_relation_id
        }
        const dataObj = vaccinationApiRequestBody({}, userDetailsObj);
        const response = await apiRequest(get_previous_response_url, dataObj, true);
        return response;
      }
      case "JioHealthHub": {
        if (!auth_token || !source_user_id) {
          return;
        }
        const userDetailsObj = {
          auth_token,
          source_id,
          jhh_id: source_user_id,
        }
        const dataObj = vaccinationApiRequestBody({}, userDetailsObj);
        const response = await apiRequest(get_previous_response_url, dataObj, true, false, false, false, false, false, false, false, true);
        return response;
      }
      default: {
        return;
      }
    }
  }

  const _captureInterestAlreadyVaccinated = async () => {
    const capture_interest_url = config.covid_vacc_base_url + "v1/capture-interest/";
    source_id = lodash.get(params, "source_id");
    switch (source_id) {
      case "emp_xp": {
        const dataObj = vaccinationApiRequestBody({ interest_value: "already-vaccinated" }, user_details.current);
        apiRequest(capture_interest_url, dataObj, true);
        return;
      }
      case "JioHealthHub": {
        const dataObj = vaccinationApiRequestBody({ interest_value: "already-vaccinated", jhh_id: source_user_id }, user_details.current);
        apiRequest(capture_interest_url, dataObj, true, false, false, false, false, false, false, false, true);
        return;
      }
      default: {
        return;
      }
    }
  }

  const _getJhhIdInfo = async () => {
    const auth_token = lodash.get(params, "auth_token");
    const source_id = lodash.get(params, "source_id").toLowerCase();
    const source_user_id = lodash.get(params, "source_user_id");
    const source_relation = lodash.get(params, "source_relation");
    const source_user_relation_id = lodash.get(params, "source_user_relation_id");
    if (!auth_token || !source_id || !source_user_id || !source_relation || (source_user_relation_id == undefined)) {
      return false;
    }
    const userDetailsObj = {
      auth_token,
      source_id,
      source_user_id,
      source_relation,
      source_user_relation_id
    };
    showLoading();
    let response;
    try {
      response = await isJhhIdVerified(userDetailsObj);
      hideLoading();
    } catch (error) {
      setPageLoadError(lodash.get(error, "message", "Something went wrong. Please try again."));
      hideLoading();
      return false
    }
    if (lodash.get(response, "status") !== "success") {
      setPageLoadError(lodash.get(response, "response.data.message", "Something went wrong. Please try again."));
      return false;
    }
    if (lodash.get(response, "validated") == "no") {
      history.push(`/vaccination-sc/verifyjhhid?${urlParams.toString()}`)
      return false;
    }
    if (lodash.get(response, "jhh_token")) {
      appStorage.setItem("jhh_token", lodash.get(response, "jhh_token"));
    }
    return true;
  }

  const _getVaccineOptions = async () => {
    const getVaccineOptionsURL = config.covid_vacc_base_url + "v1/get-covid-vaccine-list/";
    const response = await apiRequest(getVaccineOptionsURL);
    if (lodash.get(response, "status") !== "success") {
      // setPageLoadError(lodash.get(response,"response.data.message","Something went wrong. Please try again."));
      return;
    }
    let newVaccineOptions = lodash.get(response, "data", []);
    newVaccineOptions.unshift({ name: "", display_name: "Select" });
    _setVaccineOptions(newVaccineOptions);
  }

  const _getEoiSscParams = async () => {
    if (eoiSscParams.current !== undefined) {
      return eoiSscParams.current;
    }
    const getEoiSscParamsURL = config.covid_vacc_base_url + "v1/get-eoi-ssc-param/";
    const response = await apiRequest(getEoiSscParamsURL);
    if (lodash.get(response, "status") !== "success") {
      setPageLoadError(lodash.get(response, "response.data.message", "Something went wrong. Please try again."));
      return;
    }
    eoiSscParams.current = response;
    return response;
  }

  const _checkEOIPreviousResponse = async () => {
    const previousResponse = await _getPreviousResponse();
    if (lodash.get(previousResponse, "status") === "success" && lodash.get(previousResponse, "previous_response", "") !== "already-vaccinated") {
      _captureInterestAlreadyVaccinated();
    }
  }

  const _flowEngine = async () => {
    // const getJhhidInfo = lodash.get(params, "get_jhhid_info", "").toLowerCase() === "false" ? false : true;
    source_id = lodash.get(params, "source_id").toLowerCase();
    if (source_id === "emp_xp") {
      const proceedForward = await _getJhhIdInfo();
      if (!proceedForward) {
        return;
      }
    }
    showLoading()
    getUserVaccinationStatus(params).then(async (response) => {
      hideLoading();
      if (response) {

        const vaccinated = lodash.get(response, "vaccinated", false);
        if (vaccinated) {
          _checkEOIPreviousResponse();
          _setCheckPreviousResponseDose2(false);
          const vaccineDetails = lodash.get(response, "vaccine");
          const dose = lodash.get(vaccineDetails, "dose", "");
          const date_of_dose = lodash.get(vaccineDetails, "date_of_dose");
          const vaccination_sc_validity = lodash.get(response, "vaccination_sc_validity");
          const dose_2_reminder_days = getDose2reminderDays(lodash.get(vaccineDetails, "name"));
          const daysSinceLastVaccine = _calcDaysBtwDates(new Date(), date_of_dose);

          if (daysSinceLastVaccine <= vaccination_sc_validity) {
            _handleYesClick(); // goto post SC
          } else if ((daysSinceLastVaccine <= dose_2_reminder_days) || (dose === "2")) {
            _handleNoClick(); // goto generic SC
          } else {
            showLoading();
            await _getVaccineOptions();
            hideLoading();
            _setShowQuestionDose2(true);
          }
        } else {
          showLoading();
          await _getVaccineOptions();
          hideLoading();
          _setShowQuestionDose1(true);
        }
      }
    })
  }

  const _checkAge = async () => {
    userInfoFromParams.current = getUserInfoFromParams(params);
    if (userInfoFromParams.current) {
      let ageBelowLimit = false;
      showLoading();
      const response = await _getEoiSscParams();
      hideLoading();
      const sscAgeLimit = lodash.get(response, "data.ssc_min_age");
      if (sscAgeLimit != undefined && userInfoFromParams.current.age < sscAgeLimit) {
        ageBelowLimit = true;
      }
      if (ageBelowLimit) {
        _handleNoClick()
        return;
      }
      else if (userInfoFromParams.current.relation) {
        setUserRelation(userInfoFromParams.current.relation)
      }
      _flowEngine();
    }
  }

  useEffect(() => {
    recordEssParams();
    _checkAge();
  }, [])

  useEffect(() => {
    if (employeeId > 0)
      setDisableNext(false)

    else
      setDisableNext(true)
  }, [employeeId])

  const _handleYesClick = async () => {
    clearMemoizedWorkflow(`global-["${language}",true]`);
    if (employeeId)
      history.push(`/workflow?workflow_id=post_vaccine_covid_survey_v1&source_user_id=${employeeId}&${urlParams.toString()}&upload_certi=true`)

    else
      history.push(`/workflow?workflow_id=post_vaccine_covid_survey_v1&${urlParams.toString()}&upload_certi=true`)
  }

  const _handleNoClick = () => {
    clearMemoizedWorkflow(`global-["${language}",true]`);
    if (employeeId)
      history.push(`/workflow?workflow_id=covid_survey_v4&source_user_id=${employeeId}&${urlParams.toString()}`)

    else if (handleCompleteFinish)
      handleCompleteFinish()

    else
      history.push(`/workflow?workflow_id=covid_survey_v4&${urlParams.toString()}`)
  }

  const _handleEmployeeIdChange = (event) => {
    setEmployeeId(event.target.value)
  }

  if (pageLoadError) {
    return (<div className="vaccination-sc-page-load-error">{_getErrorMessage(pageLoadError)}</div>)
  }

  return (
    <div className={`vaccination-sc-wrapper symptom-checker-flow ${hideHeader ? "padding-top-very-small" : ""} ${(source_id === 'JioHealthHub' || source_id === 'MyJio' || source_id === "JhhWebApp") ? "padding-top-small" : ''}`}>
      {showEmployeeIdQues &&
        <div>
          <h4 className="vaccination-sc-header">Please enter your Employee ID for filling symptom checker</h4>
          <div>
            <InputForm
              addClassInput={`vaccination-sc-input ${employeeIdGiven ? "disabled" : ""}`}
              label="Employee Id"
              readOnly={employeeIdGiven}
              type="number"
              value={employeeId}
              onChange={_handleEmployeeIdChange}
              minValue={0}
              placeholder={"Please enter Employee ID"}
              autoFocus={true}
            />
            <br></br>
            {!employeeIdGiven &&
              <InputForm
                addClassInput={`vaccination-sc-yes-button vaccination-sc-next-button ${disableNext ? " disabled" : ""}`}
                type="button"
                value="Next"
                disabledValue={disableNext}
                onClick={() => setEmployeeIdGiven(true)}
              />
            }
          </div>
        </div>
      }
      {/* {employeeIdGiven && loadingCount < 1 && */}
      {employeeIdGiven &&
        <div>
          {(!hideHeader) && <div className="vaccination-sc-title">
            {t("VACCINATION_STATUS")}
          </div>}
          {showQuestionDose1 &&
            <UpdateVaccineDetails
              question={`${t('HI')}${name ? (` ${name}, ${t('ARE_YOU')}`) : ((userRelation && userRelation !== "Self") ? `, ${t('IS_YOUR')} ${userRelation.toLowerCase()}` : `, ${t('ARE_YOU')}`)} ${t('VACCINATION_QUESTION')} 1?`}
              doseNo={1}
              vaccine_select_options={vaccineOptions}
              params={params}
              _onSubmitFinish={() => { _setShowQuestionDose2(true) }}
              _afterYesClick={() => { _checkEOIPreviousResponse(); _setCheckPreviousResponseDose2(false) }}
              _handleNoClick={_handleNoClick}
            />
          }
          {showQuestionDose2 &&
            <UpdateVaccineDetails
              question={`${t('HI')}${name ? (` ${name}, ${t('ARE_YOU')}`) : ((userRelation && userRelation !== "Self") ? `, ${t('IS_YOUR')} ${userRelation.toLowerCase()}` : `, ${t('ARE_YOU')}`)} ${t('VACCINATION_QUESTION')} 2?`}
              doseNo={2}
              vaccine_select_options={vaccineOptions}
              params={params}
              _onSubmitFinish={_handleNoClick}
              _afterYesClick={() => { if (checkPreviousResponseDose2) { _checkEOIPreviousResponse() } }}
              _handleNoClick={_handleNoClick}
            />
          }
        </div>
      }
    </div>
  )
}

export default VaccinationScWrapper;